<template>
    <div>
        <div
            class="c-communities__tiles u-m-t4@m u-m-t3@s"
            :class="showEmptyMessage === false ? 'u-m-t1' : ''"
        >
            <div class="o-wrapper">
                <div class="o-grid o-grid--center">
                    <div
                        v-if="communities.length !== 0"
                        class="o-grid__item u-width-10/12 u-width-full@l"
                    >
                        <div
                            id="communities"
                            class="c-communities__wrapper u-m-b4"
                        >
                            <div
                                v-for="item in communities"
                                :class="['c-communities__tile', item.accredited ? 'accredited' : '']"
                            >
                                <a
                                    :href="
                                        '/u/' +
                                        $root.profile.username +
                                        '/' +
                                        item.url +
                                        '/posts'
                                    "
                                >
                                    <div
                                        class="c-communities__profile"
                                    >
                                        <img
                                            class="c-communities__img u-m-r1@s"
                                            :srcset="$simpleStore.transformImageWithCloudfront(120, 120, item.image, $root, 'srcset')"
                                            :src="$simpleStore.transformImageWithCloudfront(120, 120, item.image, $root)"
                                            :alt="item.name"
                                        >
                                        <div class="c-communities__name">
                                            {{ item.name }}
                                            <span v-if="item.total_user_posts > 1">({{ item.total_user_posts }} articles)</span>
                                            <span v-else-if="item.total_user_posts === 1">({{ item.total_user_posts }} article)</span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="c-communities__feed" v-if="$root.user.username === $root.profile.username">
                            <a href="/" class="button">Go to your feed</a>
                        </div>
                    </div>
                    <div
                        v-else
                        class="o-grid__item u-width-8/12 u-width-full@l"
                        v-if="showEmptyMessage"
                    >
                        <div
                            v-if="$root.isOwnAccount"
                            class="c-empty-state"
                        >
                            <h4>
                                Become a member of your favorite communities
                            </h4>
                            <p>
                                You are not yet a member of any communities, to
                                get started simply click on the Find a Community
                                icon below.
                            </p>
                            <a
                                class="c-empty-state__community_select u-m-t3"
                                href="/communities"
                            >
                                <div class="c-communities-select__tile">
                                    <img
                                        class="c-communities-select__img"
                                        :src="$cdn('/img/icons/icon-communities-squared--contained.svg')"
                                        width="99"
                                        height="99"
                                        alt="find communities"
                                    />
                                    <div class="c-communities-select__name">
                                        <p>Find a Community</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div v-else class="c-empty-state">
                            <h4>
                                {{ $root.profile.first_name }} is not yet a
                                member of any communities
                            </h4>
                            <p>As soon as they do they will be listed here.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Load More Button -->
        <!--<div class="o-wrapper u-m-b10">-->
        <!--<div class="o-grid o-grid&#45;&#45;center">-->
        <!--<div class="o-grid__item u-width-10/12 u-align-center">-->
        <!--<a href="#0" class="c-btn c-btn&#45;&#45;red is-outline">Load more</a>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!-- !Load More Button -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            communities: [],
            showEmptyMessage: false,
        };
    },
    created() {
        this.$root.$on('bus-profile-search-community', (data) => {
            this.fetchData(data);
        });
        this.$root.$on('bus-profile-communities-reset-cache', (data) => {
            const cacheKey = this.$simpleStore.localStorageCacheKeys.communities + '-' + this.$root.profile.user_id;
            localStorage.removeItem(cacheKey);
        });
        this.fetchData();
    },
    watch: {
        // call again the method if the route changes
        $route: "fetchData",
    },
    methods: {
        fetchData(query) {
            const cacheKey = this.$simpleStore.localStorageCacheKeys.communities + '-' + this.$root.profile.user_id;
            if (!query) {
                const cachedCommunities = this.$simpleStore.getWithSlidingExpiry(cacheKey);
                if (cachedCommunities != null) {
                    this.communities = cachedCommunities;
                    this.showEmptyMessage = this.communities.length === 0;
                    return;
                }
            }
            this.communities = [];
            this.showEmptyMessage = false;
            if (query) {
                this.$root.$emit('bus-profile-search-loading', true);
            }
            let communityData = {
                joined: 1,
                community_url: this.$root.community.url,
                query: query,
            };
            this.$http.post('/api/v1/user/' + this.$root.profile.user_id + '/communities', communityData)
                .then((response) => {
                    if (query) {
                        this.$root.$emit('bus-profile-search-loading', false);
                    }
                    this.communities = response.data.results;
                    if (this.communities.length === 0) {
                        this.showEmptyMessage = true;
                    } else {
                        // TODO: 15/7/24 add paging here - CommunitySelector.vue
                        for (let i = 1; i < response.data.total_pages; i++) {
                            let page = i + 1;
                            let communityPagedData = {
                                joined: 1,
                                community_url: this.$root.community.url,
                                query: query,
                                page: page,
                            };
                            this.$http.post('/api/v1/user/' + this.$root.profile.user_id + '/communities', communityPagedData)
                                .then((response) => {
                                    this.communities.push.apply(this.communities, response.data.results);
                                },
                                (response) => {
                                    console.log('Errored:');
                                    console.log(response);
                                }
                            );
                        }
                    }
                    if (!query) {
                        this.$simpleStore.setWithExpiry(cacheKey, this.communities);
                    }
                },
                (response) => {
                    if (query) {
                        this.$root.$emit('bus-profile-search-loading', false);
                    }
                    if (response.status === 403) {
                        this.$root.$emit('show-private-message');
                    }
                }
            );
        },
    }
};
</script>
